// extracted by mini-css-extract-plugin
module.exports = {"outlinedIcon":"OutlinedIcon_outlinedIcon__2t1aF"};